import { ListItemButton, ListItemIcon } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledNavItem = styled((props: any) => <ListItemButton disableGutters {...props} />)(({ theme }: any) => ({
	...theme.typography.body2,
	height: 48,
	position: "relative",
	textTransform: "capitalize",
	color: theme.palette.text.secondary,
	borderRadius: theme.shape.borderRadius,
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
	width: 22,
	height: 22,
	color: "inherit",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
});
